'use strict';

import angular from 'angular';

/**
 * AutorisationsRechercheController - contrôleur de la page des autorisations de recherche
 */
export default angular.module('observatoireApp')
  .controller('AutorisationsRechercheController', ['$scope', '$http', '$filter', '$timeout', 'AutorisationsService', 'MetaService',
    function($scope, $http, $filter, $timeout, AutorisationsService, MetaService) {
      // État de chargement
      $scope.loading = {
        autorisations: true,
        details: false
      };
      
      // Initialisation des filtres
      $scope.filtres = {
        texte: '',
        denomination: '',
        matiereContractee: '',
        typeAutorisation: '',
        statut: ''
      };
      
      // Options de filtres (seront remplies avec les données)
      $scope.options = {
        denominations: [],
        matieres: [],
        typesAutorisation: [],
        statuts: []
      };
      
      // Initialisation du tableau des autorisations
      $scope.autorisations = [];
      $scope.autorisationsFiltrees = [];
      
      // Autorisation sélectionnée pour affichage détaillé
      $scope.autorisationSelectionnee = null;
      
      // Pagination
      $scope.pagination = {
        pageCourante: 1,
        elementsParPage: 10,
        nombrePages: 1
      };
      
      // Tri
      $scope.tri = {
        colonne: 'datePermis',
        ordre: 'desc'
      };
      
      // Math pour les calculs dans le template
      $scope.Math = window.Math;
      
      // Initialiser les métadonnées de la page
      MetaService.setAll({
        title: 'Autorisations de recherche pétrolière - Observatoire Tchadien',
        description: 'Liste des autorisations de recherche pétrolière au Tchad avec leurs statuts, dates et informations géographiques.',
        keywords: 'autorisations recherche, pétrole, tchad, bloc pétrolier, carte interactive'
      });
      
      // Initialisation
      loadAutorisations();
      
      /**
       * Charge les autorisations de recherche
       */
      function loadAutorisations() {
        $scope.loading.autorisations = true;
        
        AutorisationsService.getAutorisations()
          .then(function(data) {
            console.log("Autorisations reçues de l'API:", data.length, data);
            $scope.autorisations = data;
            
            // Appliquer le filtrage pour éliminer les lignes vides dès le départ
            $scope.filtrerAutorisations();
            console.log("Autorisations après filtrage:", $scope.autorisationsFiltrees.length, $scope.autorisationsFiltrees);
            
            // Extraire les options pour les filtres (après filtrage des lignes vides)
            extractFilterOptions();
            
            // Trier les résultats initiaux
            trierAutorisations();
            
            $scope.loading.autorisations = false;
            
            // Initialiser la carte après le chargement des données
            // Délai court pour laisser le DOM se mettre à jour
            $timeout(function() {
              $scope.initialiserCarte();
            }, 100);
          })
          .catch(function(error) {
            console.error('Erreur lors du chargement des autorisations de recherche:', error);
            $scope.loading.autorisations = false;
          });
      }
      
      /**
       * Vérifie si une autorisation contient des données significatives ou est vide
       * @param {Object} autorisation - L'autorisation à vérifier
       * @returns {boolean} - true si l'autorisation contient des données significatives, false sinon
       */
      function isAutorisationValide(autorisation) {
        // Vérifier que les champs essentiels ne sont pas vides ou null
        if (!autorisation.denomination || autorisation.denomination.trim() === '') return false;
        if (!autorisation.reference || autorisation.reference.trim() === '') return false;
        
        // Vérifier que les autres champs importants existent
        // On peut considérer une autorisation valide même si certains champs secondaires sont vides
        let fieldsCount = 0;
        if (autorisation.matiereContractee && autorisation.matiereContractee.trim() !== '') fieldsCount++;
        if (autorisation.typeAutorisation && autorisation.typeAutorisation.trim() !== '') fieldsCount++;
        if (autorisation.statut && autorisation.statut.trim() !== '') fieldsCount++;
        if (autorisation.datePermis) fieldsCount++;
        if (autorisation.dateExpirationPrevue) fieldsCount++;
        
        // Considérer l'autorisation comme valide s'il a au moins 3 champs significatifs en plus des champs essentiels
        return fieldsCount >= 3;
      }
      
      /**
       * Extrait les options pour les filtres à partir des données d'autorisations
       */
      function extractFilterOptions() {
        // Extraire les dénominations uniques
        $scope.options.denominations = [...new Set($scope.autorisations.map(a => a.denomination))].sort();
        
        // Extraire les matières contractées uniques
        $scope.options.matieres = [...new Set($scope.autorisations.map(a => a.matiereContractee))].sort();
        
        // Extraire les types d'autorisation uniques
        $scope.options.typesAutorisation = [...new Set($scope.autorisations.map(a => a.typeAutorisation))].sort();
        
        // Extraire les statuts uniques
        $scope.options.statuts = [...new Set($scope.autorisations.map(a => a.statut))].sort();
      }
      
      /**
       * Met à jour la pagination en fonction des données filtrées
       */
      function updatePagination() {
        $scope.pagination.nombrePages = Math.ceil($scope.autorisationsFiltrees.length / $scope.pagination.elementsParPage);
        if ($scope.pagination.pageCourante > $scope.pagination.nombrePages) {
          $scope.pagination.pageCourante = 1;
        }
      }
      
      /**
       * Filtre les autorisations selon les critères de recherche
       */
      $scope.filtrerAutorisations = function() {
        $scope.autorisationsFiltrees = $scope.autorisations.filter(function(autorisation) {
          // D'abord vérifier si l'autorisation est valide (pas une ligne vide)
          if (!isAutorisationValide(autorisation)) return false;
          
          let matchTexte = true;
          let matchDenomination = true;
          let matchMatiere = true;
          let matchType = true;
          let matchStatut = true;
          
          // Filtre par texte (recherche sur plusieurs champs)
          if ($scope.filtres.texte) {
            const searchText = $scope.filtres.texte.toLowerCase();
            matchTexte = 
              (autorisation.denomination && autorisation.denomination.toLowerCase().includes(searchText)) ||
              (autorisation.reference && autorisation.reference.toLowerCase().includes(searchText)) ||
              (autorisation.matiereContractee && autorisation.matiereContractee.toLowerCase().includes(searchText)) ||
              (autorisation.typeAutorisation && autorisation.typeAutorisation.toLowerCase().includes(searchText)) ||
              (autorisation.statut && autorisation.statut.toLowerCase().includes(searchText));
          }
          
          // Filtre par dénomination
          if ($scope.filtres.denomination) {
            matchDenomination = autorisation.denomination === $scope.filtres.denomination;
          }
          
          // Filtre par matière contractée
          if ($scope.filtres.matiereContractee) {
            matchMatiere = autorisation.matiereContractee === $scope.filtres.matiereContractee;
          }
          
          // Filtre par type d'autorisation
          if ($scope.filtres.typeAutorisation) {
            matchType = autorisation.typeAutorisation === $scope.filtres.typeAutorisation;
          }
          
          // Filtre par statut
          if ($scope.filtres.statut) {
            matchStatut = autorisation.statut === $scope.filtres.statut;
          }
          
          return matchTexte && matchDenomination && matchMatiere && matchType && matchStatut;
        });
        
        // Mettre à jour la pagination après le filtrage
        updatePagination();
        
        // Réinitialiser la page courante
        $scope.pagination.pageCourante = 1;
      };
      
      /**
       * Trie les autorisations selon la colonne et l'ordre spécifiés
       */
      $scope.trierAutorisations = function(colonne) {
        if (colonne === $scope.tri.colonne) {
          // Inverser l'ordre de tri si on clique sur la même colonne
          $scope.tri.ordre = $scope.tri.ordre === 'asc' ? 'desc' : 'asc';
        } else {
          // Définir la colonne de tri et l'ordre par défaut
          $scope.tri.colonne = colonne;
          $scope.tri.ordre = 'asc';
        }
        
        trierAutorisations();
      };
      
      /**
       * Trie les autorisations selon les critères définis
       */
      function trierAutorisations() {
        $scope.autorisationsFiltrees.sort(function(a, b) {
          let valA = a[$scope.tri.colonne];
          let valB = b[$scope.tri.colonne];
          
          // Gérer les valeurs nulles ou non définies
          if (valA === undefined || valA === null) valA = '';
          if (valB === undefined || valB === null) valB = '';
          
          // Comparer selon le type de données
          let comparaison;
          if (typeof valA === 'string') {
            comparaison = valA.localeCompare(valB);
          } else {
            comparaison = valA < valB ? -1 : (valA > valB ? 1 : 0);
          }
          
          // Appliquer l'ordre de tri
          return $scope.tri.ordre === 'asc' ? comparaison : -comparaison;
        });
      }
      
      /**
       * Change de page dans la pagination
       */
      $scope.changerPage = function(page) {
        if (page < 1 || page > $scope.pagination.nombrePages || page === $scope.pagination.pageCourante) {
          return;
        }
        $scope.pagination.pageCourante = page;
      };
      
      /**
       * Génère la liste des pages à afficher dans la pagination
       */
      $scope.getPages = function() {
        const pages = [];
        const totalPages = $scope.pagination.nombrePages;
        const currentPage = $scope.pagination.pageCourante;
        
        // Limiter le nombre de pages affichées
        const maxPagesToShow = 5;
        
        if (totalPages <= maxPagesToShow) {
          // Si le nombre total de pages est petit, afficher toutes les pages
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
          }
        } else {
          // Sinon, afficher les pages autour de la page courante
          let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
          let endPage = startPage + maxPagesToShow - 1;
          
          // Ajuster si on dépasse le nombre total de pages
          if (endPage > totalPages) {
            endPage = totalPages;
            startPage = Math.max(1, endPage - maxPagesToShow + 1);
          }
          
          for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
          }
        }
        
        return pages;
      };
      
      /**
       * Affiche les détails d'une autorisation
       * @param {Object|number} autorisationParam - L'autorisation ou son ID
       */
      $scope.afficherDetails = function(autorisationParam) {
        let autorisation;
        
        // Si on nous passe directement un ID (depuis le popup de la carte)
        if (typeof autorisationParam === 'number' || (typeof autorisationParam === 'string' && !isNaN(autorisationParam))) {
          // Rechercher l'autorisation correspondante dans le tableau
          const id = parseInt(autorisationParam, 10);
          autorisation = $scope.autorisations.find(a => a.id === id);
          
          if (!autorisation) {
            console.error('Autorisation non trouvée avec l\'ID:', id);
            return;
          }
        } else {
          // C'est un objet autorisation complet
          autorisation = autorisationParam;
        }
        
        $scope.autorisationSelectionnee = angular.copy(autorisation);
        $scope.loading.details = true;
        $scope.erreurDetails = null;
        
        // Faire une copie propre de l'autorisation pour éviter les modifications non désirées
        $scope.autorisationSelectionnee = angular.copy(autorisation);
        
        // Pré-initialiser les structures de données pour éviter les erreurs
        if (!$scope.autorisationSelectionnee.documents) {
          $scope.autorisationSelectionnee.documents = [];
        }
        
        // Afficher le titre de l'autorisation dans le header du modal
        var titleEl = document.querySelector('#modalDetailsAutorisation .modal-title');
        if (titleEl) titleEl.textContent = 'Détails de l\'autorisation: ' + $scope.autorisationSelectionnee.reference;
        
        // Afficher le modal Bootstrap 5
        var el = document.getElementById('modalDetailsAutorisation');
        if (el) bootstrap.Modal.getOrCreateInstance(el, { backdrop: 'static', keyboard: false }).show();
        
        // En parallèle, charger les détails additionnels
        $timeout(function() {
          AutorisationsService.getAutorisationDetails(autorisation.id)
            .then(function(details) {
              if (details) {
                $scope.autorisationSelectionnee.details = details;
              }
              $scope.loading.details = false;
            })
            .catch(function(error) {
              console.error('Erreur lors du chargement des détails de l\'autorisation:', error);
              $scope.loading.details = false;
              $scope.erreurDetails = 'Impossible de charger tous les détails de l\'autorisation.';
            });
        }, 200);
      };
      
      /**
       * Ferme le modal de détails
       */
      $scope.fermerDetails = function() {
        // Fermer le modal avec l'API Bootstrap
        var el = document.getElementById('modalDetailsAutorisation');
        if (el) { var m = bootstrap.Modal.getInstance(el); if (m) m.hide(); }
        
        // Réinitialiser les états après la fermeture du modal
        $timeout(function() {
          $scope.autorisationSelectionnee = null;
          $scope.erreurDetails = null;
        }, 300); // Laisser le temps à l'animation de fermeture de se terminer
      };
      
      /**
       * Retourne le lien réel du document de l'autorisation (lien_reference en base,
       * sinon le premier document attaché)
       */
      $scope.lienAutorisation = function(autorisation) {
        if (!autorisation) return null;
        if (autorisation.lienReference) return autorisation.lienReference;
        const doc = (autorisation.documents || []).find(function(d) { return d && d.url; });
        return doc ? doc.url : null;
      };
      
      /**
       * Réinitialise les filtres
       */
      $scope.reinitialiserFiltres = function() {
        $scope.filtres = {
          texte: '',
          denomination: '',
          matiereContractee: '',
          typeAutorisation: '',
          statut: ''
        };
        $scope.filtrerAutorisations();
      };
      
      /**
       * Exporte les données au format Excel
       */
      $scope.exporterExcel = function() {
        AutorisationsService.exporterAutorisations($scope.autorisationsFiltrees)
          .then(function(response) {
            // Simuler un téléchargement
            const element = document.createElement('a');
            const file = new Blob([response.data], {type: response.headers('Content-Type')});
            element.href = URL.createObjectURL(file);
            element.download = 'Autorisations_recherche.xlsx';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
          })
          .catch(function(error) {
            console.error('Erreur lors de l\'exportation Excel:', error);
            alert('Erreur lors de l\'exportation des données. Veuillez réessayer.');
          });
      };
      
      /**
       * Imprime la liste des autorisations
       */
      $scope.imprimer = function() {
        window.print();
      };
      
      /**
       * Initialise la carte Leaflet avec les autorisations de recherche
       */
      $scope.initialiserCarte = function() {
        // Vérifier si Leaflet est disponible dans l'environnement global
        if (typeof L === 'undefined') {
          console.error('Leaflet n\'est pas disponible (L non défini)');
          return;
        }
        
        // Vérifier si l'élément existe dans le DOM
        const mapContainer = document.getElementById('recherche-map');
        if (!mapContainer) {
          console.error('Container de carte non trouvé (id: recherche-map)');
          setTimeout($scope.initialiserCarte, 500); // Réessayer après un délai
          return;
        }

        // Coordonnées du centre du Tchad
        const centerLat = 12.1348;
        const centerLng = 15.0557;
        const defaultZoom = 5;

        // Initialiser la carte
        const map = L.map('recherche-map', {
          center: [centerLat, centerLng],
          zoom: defaultZoom,
          scrollWheelZoom: false
        });

        // Ajouter les couches de fond (tile layers)
        const osmLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; OpenStreetMap contributors',
          maxZoom: 18
        }).addTo(map);

        const satelliteLayer = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
          attribution: 'Source: Esri, DigitalGlobe, GeoEye, Earthstar Geographics',
          maxZoom: 18
        });

        // Grouper les couches de fond
        const baseMaps = {
          "OpenStreetMap": osmLayer,
          "Satellite": satelliteLayer
        };

        // Créer un groupe de marqueurs avec clustering
        const markers = L.markerClusterGroup();

        // Uniquement à titre d'exemple - dans une vraie implémentation,
        // il faudrait obtenir les coordonnées réelles de chaque bloc pétrolier
        const coordsExemples = [
          { lat: 11.2, lng: 16.1 },  // Coordonnées fictives des blocs pétroliers
          { lat: 12.5, lng: 15.9 },
          { lat: 10.8, lng: 14.7 },
          { lat: 11.6, lng: 15.3 },
          { lat: 12.9, lng: 16.5 },
          { lat: 13.1, lng: 14.8 },
          { lat: 10.5, lng: 16.2 }
        ];
        
        // Ajouter des marqueurs pour chaque autorisation
        $scope.autorisationsFiltrees.forEach((autorisation, index) => {
          // Utiliser des coordonnées de manière cyclique si on a plus d'autorisations que de coordonnées
          if (coordsExemples.length > 0) {
            const position = coordsExemples[index % coordsExemples.length];
            const statut = autorisation.statut || 'Non défini';
            
            // Définir la couleur du marqueur selon le statut
            let markerColor = '#7F7F7F'; // Gris par défaut
            if (statut.includes('vigueur') || statut.includes('approuvé')) {
              markerColor = '#5cb85c'; // Vert
            } else if (statut.includes('expiré') || statut.includes('terminé')) {
              markerColor = '#d9534f'; // Rouge
            } else if (statut.includes('attente') || statut.includes('suspendu')) {
              markerColor = '#f0ad4e'; // Orange
            }
            
            // Créer une icône personnalisée pour le marqueur
            const markerIcon = L.divIcon({
              className: 'custom-marker',
              html: `<div style="background-color: ${markerColor}; width: 20px; height: 20px; border-radius: 50%; border: 2px solid white;"></div>`,
              iconSize: [20, 20],
              iconAnchor: [10, 10]
            });
            
            // Créer le marqueur avec popup
            const marker = L.marker([position.lat, position.lng], {
              icon: markerIcon,
              title: autorisation.denomination
            });
            
            // Contenu du popup
            const popupContent = `
              <div class="marker-popup">
                <h4>${autorisation.denomination || 'Non spécifié'}</h4>
                <p><strong>Référence:</strong> ${autorisation.reference || 'Non spécifié'}</p>
                <p><strong>Type:</strong> ${autorisation.typeAutorisation || 'Non spécifié'}</p>
                <p><strong>Statut:</strong> <span class="text-${statut.toLowerCase().includes('vigueur') ? 'success' : (statut.toLowerCase().includes('expiré') ? 'danger' : 'warning')}">${statut}</span></p>
                <p><button class="btn btn-sm btn-primary btn-details" onclick="angular.element('#recherche-map').scope().afficherDetails(${autorisation.id})">Voir détails</button></p>
              </div>
            `;
            
            marker.bindPopup(popupContent);
            markers.addLayer(marker);
          }
        });
        
        // Ajouter le groupe de marqueurs à la carte
        map.addLayer(markers);
        
        // Ajouter le contrôle des couches
        L.control.layers(baseMaps, {
          "Autorisations": markers
        }).addTo(map);
        
        // Ajouter une légende
        const legend = L.control({position: 'bottomright'});
        legend.onAdd = function(map) {
          const div = L.DomUtil.create('div', 'info legend');
          div.innerHTML = `
            <div style="background: white; padding: 10px; border-radius: 5px; box-shadow: 0 0 15px rgba(0,0,0,0.2);">
              <h4>Légende</h4>
              <div style="margin-top: 5px;">
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="background-color: #5cb85c; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>En vigueur</span>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="background-color: #f0ad4e; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>En attente/Suspendu</span>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 5px;">
                  <div style="background-color: #d9534f; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>Expiré/Terminé</span>
                </div>
                <div style="display: flex; align-items: center;">
                  <div style="background-color: #7F7F7F; width: 15px; height: 15px; border-radius: 50%; margin-right: 8px;"></div>
                  <span>Autre</span>
                </div>
              </div>
            </div>
          `;
          return div;
        };
        legend.addTo(map);
        
        // Stocker la référence de la carte dans $scope pour y accéder plus tard
        $scope.map = map;
        
        console.log('Carte Leaflet initialisée avec succès pour les autorisations de recherche');
      };
    }
  ]);
